import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ApiService } from "./api.service";
import Raven from 'raven-js';

@Injectable()
export class SearchService {
  public searchStore: BehaviorSubject<any>;
  private searchTerm: string = '';
  private params: string = 'help_category=ALL&sale_category=ALL&housing_category=ALL&job_category=ALL&job_branche=ALL';
  public loadingStore: BehaviorSubject<any>;

  page: number = 1;

  constructor(private _apiService: ApiService) {
    this.searchStore = new BehaviorSubject<any>(null);
    this.loadingStore = new BehaviorSubject<any>(true);
    this.doSearch(); // initial search for home page
  }

  getSearchTerm() {
    return this.searchTerm;
  }

  setSearchTerm(searchTerm) {
    this.page = 1;
    this.searchTerm = searchTerm;
    this.doSearch();
  }

  setParams(params) {
    this.page = 1;
    this.params = params;
    this.doSearch();
  }

  doSearch() {
    this.loadingStore.next(true);
    this._apiService.search('search?' + this.params + '&fulltext=' + this.searchTerm).then(res => {
      this.searchStore.next(res);
      this.loadingStore.next(false);
    }).catch(err => {
      Raven.captureMessage(err, {
        extra: {
          location: 'SearchService',
          searchTerm: this.searchTerm,
          params: this.params,
          page: 1
        }
      });
    });
  }

  getNextPage() {
    return new Promise((resolve, reject) => {
      this.page++;
      this._apiService.search('search?' + this.params + '&fulltext=' + this.searchTerm + '&page=' + this.page).then(res => {
        resolve(res);
      }).catch(err => {
        Raven.captureMessage(err, {
          extra: {
            location: 'SearchService',
            searchTerm: this.searchTerm,
            params: this.params,
            page: this.page
          }
        });
        reject(err);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/search.service.ts